import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type WizardNavProps = {
  onBack?: () => void;
  primaryText: string;
  onPrimary: () => void;
  primaryDisabled?: boolean;
};

/** Mockup-style wizard footer: outlined Indietro on the left, solid primary on the right. */
export const WizardNav: FC<WizardNavProps> = ({ onBack, primaryText, onPrimary, primaryDisabled }) => {
  const { t } = useTranslation('comuni');
  return (
    <div className='mt-8 flex items-center justify-between'>
      <button
        type='button'
        disabled={!onBack}
        onClick={onBack}
        className={`rounded-[10px] border px-7 py-3 text-[15px] font-bold ${
          onBack ? 'bg-white-100 text-primary-900 hover:bg-secondary-background' : 'cursor-default bg-white-100 text-quaternary-300'
        }`}
      >
        {t('composer.back')}
      </button>
      <button
        type='button'
        disabled={primaryDisabled}
        onClick={onPrimary}
        className={`rounded-[10px] px-9 py-3 text-[15px] font-bold ${
          primaryDisabled ? 'cursor-default bg-quaternary-100 text-quaternary-400' : 'bg-brand-700 text-white-100 hover:bg-brand-800'
        }`}
      >
        {primaryText}
      </button>
    </div>
  );
};
